import React from 'react';
import classnames from 'classnames';
import EmployeeInfo from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderDetails/components/EmployeeInfo';
import { IEmployeesPropsType } from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/types';
import './index.scss';

const Employees: React.FC<IEmployeesPropsType> = (props) => {
  const { organization, employees, showCount = employees?.length || 0 } = props;

  if (!Array.isArray(employees) || !employees.length) return null;

  return (
    <ul className="dbg-detail-stakeholder-employee-list employee-list">
      {employees?.map((employee: any, idx) => (
        <li
          key={employee?.name}
          className={classnames('employee-item', {
            show: idx + 1 <= showCount,
            'has-mb': idx + 1 <= showCount - 2,
          })}
        >
          <EmployeeInfo organization={organization} {...employee} />
        </li>
      ))}
    </ul>
  );
};

export default React.memo(Employees);
